<template>
    <div>
      <input 
        type="number" 
        v-model="kFactor" 
        class="form-control" 
        :min="0.001" 
        :max="20"
        @input="formatNumber"
      >
    </div>
  </template>
  
  <script>
  export default {
    name: 'FieldKFactor',
    props: {
      value: Number
    },
    data() {
      return {
        kFactor: this.value
      };
    },
    watch: {
      value(newVal) {
        this.kFactor = newVal;
      },
      kFactor(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      formatNumber() {
        this.kFactor = Number(this.kFactor).toLocaleString();
      }
    }
  }
  </script>
  